<template>
    <v-dialog
        :value="isOpen"
        max-width="400px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zlecenia dla zamówienia: <strong>{{ procNumber }}</strong>
                </h1>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="reportOrderJobsListData"
                :mobile-breakpoint="0"
                name="reportsData"
                hide-default-footer
            >
                <template #item.jobNumber="{item}">
                    {{ item.jobNumber }}
                </template>
                <template #item.plateNumber="{item}">
                    {{ item.plateNumber }}
                </template>
                <template slot="no-results" :value="true">
                    <p class="text-center">
                        Brak danych
                    </p>
                </template>
            </v-data-table>
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ReportOrderJobsListDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        reportOrderJobsListData: {
            type: Array,
            default: () => []
        },
        procNumber: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Zlecenie',
                    value: 'jobNumber',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Montaż',
                    value: 'plateNumber',
                    sortable: false,
                    align: 'center',
                },
            ],
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>